import React from "react";
import { Box, Container, Typography, Stack, Divider } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useState } from "react";
import LegalDialog from "./legalDialog";
import { useLandingPage } from "../context/LandingPageContext";

const footerLinks = {
  "Quick Links": [
    { label: "Home", href: "#home" },
    { label: "Features", href: "#features" },
    { label: "Benefits", href: "#benefits" },
    { label: "Stories", href: "#stories" },
  ],
  Tools: [
    { label: "Wellness", href: "#features" },
    { label: "Sleep support", href: "#features" },
    { label: "Guided meditation", href: "#features" },
    { label: "Mindfulness", href: "#features" },
    { label: "Breathing Exercises", href: "#features" },
  ],
  "Useful links": [
    { label: "Terms and Conditions", href: "#" },
    { label: "Privacy policy", href: "#" },
  ],
};

// const socialLinks = [
//   { icon: <FacebookIcon fontSize="small" />, label: "Facebook" },
//   { icon: <InstagramIcon fontSize="small" />, label: "Instagram" },
//   { icon: <LinkedInIcon fontSize="small" />, label: "LinkedIn" },
//   { icon: <TwitterIcon fontSize="small" />, label: "Twitter" },
//   { icon: <YouTubeIcon fontSize="small" />, label: "YouTube" },
// ];

export default function FooterSection() {
  const { landingData } = useLandingPage();

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState("");

  const handleOpenDialog = (type) => {
    setDialogType(type);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };


  const socialLinks = landingData?.showSocialMedia
    ? [
        {
          label: "Facebook",
          url: landingData.facebookUrl,
          icon: <FacebookIcon fontSize="small" />,
        },
        {
          label: "Instagram",
          url: landingData.instagramUrl,
          icon: <InstagramIcon fontSize="small" />,
        },
        {
          label: "LinkedIn",
          url: landingData.linkedinUrl,
          icon: <LinkedInIcon fontSize="small" />,
        },
        {
          label: "Twitter",
          url: landingData.twitterUrl,
          icon: <TwitterIcon fontSize="small" />,
        },
        {
          label: "YouTube",
          url: landingData.youtubeUrl,
          icon: <YouTubeIcon fontSize="small" />,
        },
      ].filter((social) => social.url) // removes null/empty URLs
    : [];

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#F7F8F5",
        pt: { xs: 6, sm: 8, md: 6 },
        pb: { xs: 4, sm: 5 },
        px: { xs: 4, sm: 4, md: "80px" },
      }}
    >
      <Container maxWidth="xl" disableGutters>
        {/* Top row: Brand + Link columns */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            gap: { xs: 5, md: 4 },
            mb: { xs: 5, md: 6 },
          }}
        >
          {/* Brand column */}
          <Box sx={{ maxWidth: { xs: "100%", md: "280px" } }}>
            <Typography
              sx={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: 700,
                fontSize: "24px",
                color: "#1B3B2B",
                mb: 2,
                letterSpacing: "-0.3px",
              }}
            >
              Zeniv
            </Typography>
            <Typography
              sx={{
                fontFamily: "'Outfit', sans-serif",
                fontWeight: 400,
                fontSize: "15px",
                lineHeight: 1.7,
                color: "rgba(27,59,43,0.65)",
                mb: 3,
              }}
            >
              Step into calm with expert-led sessions designed to relax your
              mind and restore focus. Whether you're a beginner or experienced,
              guided meditation helps reduce stress, improve clarity, and build
              a deeper sense of inner peace.
            </Typography>
            {/* <Stack direction="row" spacing={1.5}>
              {socialLinks.map((social) => (
                <Box
                  key={social.label}
                  aria-label={social.label}
                  sx={{
                    width: 38,
                    height: 38,
                    borderRadius: "50%",
                    backgroundColor: "#1B3B2B",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#FFFFFF",
                    cursor: "pointer",
                    transition: "all 0.25s ease",
                    "&:hover": {
                      backgroundColor: "#2D5A43",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  {social.icon}
                </Box>
              ))}
            </Stack> */}
            {socialLinks.length > 0 && (
              <Stack direction="row" spacing={1.5}>
                {socialLinks.map((social) => (
                  <Box
                    key={social.label}
                    component="a"
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    sx={{
                      width: 38,
                      height: 38,
                      borderRadius: "50%",
                      backgroundColor: "#1B3B2B",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#FFFFFF",
                      cursor: "pointer",
                      textDecoration: "none",
                      transition: "all 0.25s ease",
                      "&:hover": {
                        backgroundColor: "#2D5A43",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    {social.icon}
                  </Box>
                ))}
              </Stack>
            )}
          </Box>

          {/* Link columns */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(2, 1fr)",
                sm: "repeat(3, 1fr)",
              },
              gap: { xs: 4, sm: 6, md: 8 },
              flex: 1,
              maxWidth: { md: "700px" },
            }}
          >
            {Object.entries(footerLinks).map(([category, links]) => (
              <Box key={category}>
                <Typography
                  sx={{
                    fontFamily: "'Outfit', sans-serif",
                    fontWeight: 700,
                    fontSize: "14px",
                    color: "#1B3B2B",
                    mb: 2,
                    letterSpacing: "0.8px",
                  }}
                >
                  {category}
                </Typography>
                <Stack spacing={1.5}>
                  {links.map((link) => (
                    <Typography
                      key={link.label}
                      component="a"
                      href={
                        link.label === "Terms and Conditions" ||
                        link.label === "Privacy policy"
                          ? undefined
                          : link.href
                      }
                      onClick={(e) => {
                        if (link.label === "Terms and Conditions") {
                          e.preventDefault();
                          handleOpenDialog("terms");
                        }

                        if (link.label === "Privacy policy") {
                          e.preventDefault();
                          handleOpenDialog("privacy");
                        }
                      }}
                      sx={{
                        fontFamily: "'Outfit', sans-serif",
                        fontWeight: 400,
                        fontSize: "14px",
                        color: "rgba(27,59,43,0.6)",
                        textDecoration: "none",
                        cursor: "pointer",
                        transition: "color 0.2s ease",
                        "&:hover": {
                          color: "rgba(27,59,43,0.9)",
                        },
                      }}
                    >
                      {link.label}
                    </Typography>
                  ))}
                </Stack>
              </Box>
            ))}
          </Box>
        </Box>

        <Divider
          sx={{ borderColor: "rgba(27,59,43,0.1)", mb: { xs: 3, md: 4 } }}
        />

        {/* Bottom row */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "'Outfit', sans-serif",
              fontWeight: 400,
              fontSize: "13px",
              color: "rgba(27,59,43,0.5)",
              textAlign: "center",
            }}
          >
            {new Date().getFullYear()} Zeniv. All rights reserved.
          </Typography>
        </Box>
      </Container>
      <LegalDialog
        open={openDialog}
        onClose={handleCloseDialog}
        type={dialogType}
      />
    </Box>
  );
}
